import DayjsUtils from '@date-io/dayjs';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from '@material-ui/icons/Search';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";
import { useActions, useValues } from 'kea';
import SortIcon from '@material-ui/icons/Sort';

import vehiclelogic from 'src/store/vehicle';
import { minHistoryDate } from 'src/utils/constants';
import { Box, IconButton, Link, Tooltip } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px",
		maxHeight: 400
	},
	limitFont: {
		fontSize: 13
	}
});


export default function History({ vehicle }) {
	const classes = useStyles();

	const { history } = useValues(vehiclelogic);
	const { fetchHistory } = useActions(vehiclelogic);

	const [selectedDate, handleDateChange] = useState(new Date());
	const [displayedHistory, setDisplayedHistory] = useState([]);
	const [ascending, setAscending] = useState(false)
	const [total, setTotals] = useState({ towed: { hrs: 0, kms: 0 }, driving: { hrs: 0, kms: 0 }, stopped: { hrs: 0, kms: 0 }, idle: { hrs: 0, kms: 0 } })

	useEffect(() => {
		setDisplayedHistory(history);
		let tmp = { towed: { hrs: 0, kms: 0 }, driving: { hrs: 0, kms: 0 }, stopped: { hrs: 0, kms: 0 }, idle: { hrs: 0, kms: 0 } };
		if (history.status) {
			// eslint-disable-next-line no-unused-expressions
			history?.status?.forEach((item) => {
				if (item.event === 'Towed') {
					tmp.towed.hrs += item.duration || 0;
					tmp.towed.kms += item.distance || 0;
				}
				if (item.event === 'Driving') {
					tmp.driving.hrs += item.duration || 0;
					tmp.driving.kms += item.distance || 0;
				}
				if (item.event === 'Stopped') {
					tmp.stopped.hrs += item.duration || 0;
				}
				if (item.event === 'Idle') {
					tmp.idle.hrs += item.duration || 0;
				}
			})
			setTotals(tmp);
		}
	}, [history])

	const handleSearch = () => {
		fetchHistory({
			_id: vehicle._id,
			start: dayjs(selectedDate).startOf('day'),
			stop: dayjs(selectedDate).endOf('day')
		})
	}

	const handleSort = () => {
		if (ascending) {
			displayedHistory.status.sort((a, b) => new Date(b.start_time) - new Date(a.start_time))
		} else {
			displayedHistory.status.sort((a, b) => new Date(a.start_time) - new Date(b.start_time))
		}
		setAscending(!ascending)
	}

	return (
		<div className={classes.root} >
			<TableContainer style={{ maxHeight: '400px' }}>
				<Table stickyHeader size="small" aria-label="a dense table" className={classes.table}>
					<TableHead>
						<TableRow key={"type-rego"}>
							<TableCell align="right">
								<b>{`Pick a Date: `}</b>
							</TableCell>
							<TableCell align="center" style={{ paddingRight: 0, fontSize: 22 }}>
								<MuiPickersUtilsProvider utils={DayjsUtils}>
									<DatePicker
										autoOk
										ampm={false}
										variant="inline"
										format="DD/MM/YYYY"
										value={selectedDate}
										minDate={minHistoryDate}
										onChange={handleDateChange}
										disableFuture
									/>
								</MuiPickersUtilsProvider>
							</TableCell>
							<TableCell align="left" style={{ paddingLeft: 0 }}>
							</TableCell>
							<TableCell align="left" style={{ paddingLeft: 0 }}>
								<Button
									variant="contained"
									color="primary"
									size="small"
									className={classes.button}
									startIcon={<SearchIcon />}
									onClick={handleSearch}
								>
									Search
								</Button>
								{/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
								<SearchIcon />
							</IconButton> */}
							</TableCell>
							<TableCell align="left" style={{ paddingLeft: 0 }}>
								<Tooltip title="Sort Ascending/Descending">
									<IconButton onClick={handleSort}>
										<SortIcon />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell colSpan={2} className={classes.limitFont} style={{ minWidth: '170px' }} align="left">
								<Box py="5px">
									{history?.status && <>
										<b>Towed:</b> {total.towed.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.towed.hrs) * 1000)).humanize() : `${total.towed.hrs} hour`} ({total.towed.kms / 1000} kms)<br />
										<b>Driving:</b> {total.driving.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.driving.hrs) * 1000)).humanize() : `${total.driving.hrs} hour`} ({total.driving.kms / 1000} kms)<br />
									</>}
								</Box>
							</TableCell>
							<TableCell colSpan={4} className={classes.limitFont} style={{ minWidth: '170px' }} align="left">
								<Box py="5px">
									{history?.status && <>
										<b>Stopped:</b> {total.stopped.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.stopped.hrs) * 1000)).humanize() : `${total.stopped.hrs} hour`}<br />
										<b>Idle:</b> {total.idle.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.idle.hrs) * 1000)).humanize() : `${total.idle.hrs} hour`}
									</>}
								</Box>
							</TableCell>
						</TableRow>
						{
							// rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
							displayedHistory?.status?.map((row, index) => {
								return (
									<TableRow key={`inginition-address-${index}`}>
										<TableCell className={classes.limitFont} style={{ minWidth: '170px' }} align="left">
											<b>{row.event}{row.stop && row.start && ` (${dayjs.duration(dayjs(row?.start?.position_timestamp).diff(dayjs(row?.stop?.position_timestamp))).humanize()})`}:</b><br />
											{dayjs(row.start_time).format('DD-MM-YYYY HH:mm:ss')}<br />
										</TableCell>
										<TableCell className={classes.limitFont} colSpan={4} align="left">
											From: <Link target="_blank" rel="noopener"
												href={`https://www.google.com/maps/place/${row.start.latitude},${row.start.longitude}`}>
												{row.start?.address}
											</Link><br />
											To: {row.stop && <Link target="_blank" rel="noopener"
												href={`https://www.google.com/maps/place/${row.stop.latitude},${row.stop.longitude}`}>
												{row.stop?.address}
											</Link>}{!row.stop ? 'Ongoing' : ''}
										</TableCell>
										{/* <TableCell className={classes.limitFont} align="left">
											<Link target="_blank" rel="noopener"
												href={`https://www.google.com/maps/place/${row.start.latitude},${row.start.longitude}`}>
												{row.start?.address}
											</Link>
										</TableCell>
										<TableCell className={classes.limitFont} align="left">
											{row.stop && <Link target="_blank" rel="noopener"
												href={`https://www.google.com/maps/place/${row.stop.latitude},${row.stop.longitude}`}>
												{row.stop?.address || 'Ongoing'}
											</Link>}
										</TableCell> */}
									</TableRow>
								)
							})
						}
						{/* {emptyRows > 0 && (
					<TableRow style={{ height: 49 * emptyRows }}>
						<TableCell colSpan={6} />
					</TableRow>
				)} */}
					</TableBody>
				</Table>
			</TableContainer>

			{/* <TablePagination
			rowsPerPageOptions={[5,10,15]}
			component="div"
			count={rows.length}
			rowsPerPage={rowsPerPage}
			page={page}
			onChangePage={handleChangePage}
			onChangeRowsPerPage={handleChangeRowsPerPage}
		/> */}
		</div>
	);
}
